import { t } from '@lingui/macro';

export const getRouteTexts = () => {
    return {
        '/': t`Home`,
        '/developer': t`Apps`,
        '/basic': t`Basic`,
        '/home': t`Home`,

        '/system': t`System`,
        '/system/companies': t`Companies`,
        '/system/companies/active': t`Active companies`,
        '/system/companies/free': t`Free subscriptions`,
        '/system/companies/trials/active': t`Active trials`,
        '/system/companies/barred': t`Barred`,
        '/system/companies/deregistered': t`Deregistered`,
        '/system/companies/trials': t`Trial companies`,
        '/system/companies/trials/master': t`Trial master companies`,

        '/system/admins': t`Administrators`,
        '/system/admins/active': t`Active`,
        '/system/admins/barred': t`Barred`,
        '/system/admins/deregistered': t({ message: 'Deregistered', context: 'Afmeldte' }),
        '/system/admins/groups': t`Administrator groups`,
        '/system/admins/services': t`Services`,
        '/system/admins/user-education': t`User education`,

        '/system/notes': t`Notes`,
        '/system/notes/follow-ups': t`Follow-ups`,

        '/system/texts': t`Texts`,
        '/system/texts/popups/module': t`Module popups`,
        '/system/texts/emails/notifications': t`Notification e-mails`,
        '/system/texts/emails/vctemplates': t`Visma Connect e-mail templates`,
        '/system/texts/emails/modules': t`Module e-mails`,
        '/system/texts/popups/notifications': t`Notification popups`,

        '/system/edition': t`Country settings`,
        '/system/edition/settings': t`Country settings`,
        '/system/edition/dashboard': t`Dashboard support`,

        '/system/invoicing': t`Invoicing`,

        '/system/statistics': t`Statistics`,
        '/system/statistics/subscriptions': t`Subscriptions`,
        '/system/statistics/signups': t`Signups`,
        '/system/statistics/deregistrations': t`Deregistrations`,
        '/system/statistics/admin-notes': t`Admininistrator notes`,
        '/system/statistics/invoice-basis': t`Invoice basis`,

        '/system/advanced': t`Advanced`,
        '/system/advanced/commands': t`Commands (development)`,

        '/system/feedback': t`Feedback`,
        '/system/feedback/user-panel': t`User Panel`,

        '/system/addons': t`Market`,
        '/system/addons/management': t`Addon modules`,
        '/system/addons/mobile': t`Mobile Manager`,
        '/system/addons/store': t`Store Manager`,
        '/system/addons/campaign': t`Campaign Manager`,
        '/system/addons/switcher-feedback': t`Switcher feedback`,

        '/system/feedback/addon-deregister': t`Addon deregister`,
        '/system/feedback/feature-feedback': t`Feature feedback`,

        '/admin': t`Administrator`,
        '/admin/master-information': t`Master information`,
        '/admin/users': t`Users`,
        '/admin/services': t({ message: 'Services', context: 'Ydelser' }),
        '/admin/website-text': t`Website text`,
        '/admin/log': t`Log`,

        '/admin/companies': t`Companies`,
        '/admin/companies/prices': t`Price list`,
        '/admin/companies/request-access': t`Request access`,
        '/admin/companies/report-cover-templates': t`Report cover templates`,

        '/admin/defaults': t`Default setups`,
        '/admin/defaults/setups': t`Default setups`,
        '/admin/defaults/accounts': t`Chart of accounts`,
        '/admin/defaults/mirror-codes': t`Mirror codes`,
        '/admin/defaults/system-accounts': t`System accounts`,
        '/admin/defaults/vat-codes': t`VAT codes`,
        '/admin/defaults/charge-accounts': t`Charge accounts`,
        '/admin/defaults/groups': t`Admin groups`,
        '/admin/defaults/groups/suppliers': t`Supplier groups`,
        '/admin/defaults/groups/customers': t`Customer groups`,
        '/admin/defaults/groups/products': t`Product groups`,
        '/admin/defaults/groups/assets': t`Asset groups`,
        '/admin/defaults/units': t`Units`,
        '/admin/defaults/journals': t`Journals`,
        '/admin/defaults/payment-terms': t`Payment terms`,
        '/admin/defaults/design-and-layout': t`Design and layout`,
        '/admin/defaults/number-series': t`Number series`,

        '/sales': t`Sales`,
        '/sales/invoicing': t`Invoicing`,
        '/sales/invoicing/invoices': t`Invoices`,
        '/sales/invoicing/invoices/new': t`New invoice`,
        '/sales/invoicing/quotations': t`Quotes`,
        '/sales/invoicing/quotations/new': t`New quote`,
        '/sales/invoicing/orders': t`Orders`,
        '/sales/invoicing/orders/new': t`New order`,
        '/sales/invoicing/reminders': t`Reminders`,
        '/sales/invoicing/archive': t`Archive`,
        '/sales/invoicing/archive/invoices': t`Archive - invoices`,
        '/sales/invoicing/sent': t`Sent`,
        '/sales/invoicing/subscription': t`Subscriptions`,
        '/sales/invoicing/pbs': t`PBS`,
        '/sales/invoicing/avtalegiro': t`AvtaleGiro`,
        '/sales/invoicing/autogiro': t`Autogiro`,
        '/sales/invoicing/manual-invoices': t`Manual invoices`,

        // '/sales/dashboardV2': 'FIREBIRD_LEFTMENU_SALES_DASHBOARD', // TODO: MISSING!

        '/sales/customers': t`Customers`,
        '/sales/customers/groups': t`Customer groups`,
        '/sales/customers/ledger-cards': t`Customer ledger cards`,

        '/sales/products': t`Products`,
        '/sales/products/groups': t`Product groups`,
        '/sales/products/product-collections': t`Product Collections`,

        '/sales/setup': t`Setup`,
        '/sales/setup/customer': t`Customer setup`,
        '/sales/setup/payment-terms': t`Payment terms`,
        '/sales/setup/units': t`Units`,
        '/sales/setup/design-and-layout': t`Design and layout`,
        '/sales/setup/employees': t`Employees`,
        '/sales/setup/rot-deduction': t`ROT deduction`,
        '/sales/setup/discount-groups': t`Discount groups`,
        '/sales/setup/email-templates': t`E-mail templates`,

        '/accounting': t`Accounting`,
        '/accounting/journals': t`Journals`,
        '/accounting/lists': t`Searches and lists`,
        '/accounting/lists/accounts': t`Chart of accounts`,
        '/accounting/lists/mirror-codes': t`Mirror codes`,
        '/accounting/lists/suppliers': t`Suppliers`,
        '/accounting/lists/assets': t`Assets`,
        '/accounting/lists/entries': t`Find entries`,
        '/accounting/lists/prepayments': t`Prepayments`,
        '/accounting/lists/balance-posting': t`Balance posting`,

        '/accounting/document-requests': t`Document request`,
        '/accounting/document-requests/entries-without-documents': t`Request documents`,
        '/accounting/document-requests/review': t`Documents for review`,

        '/accounting/bank': t`Bank`,
        '/accounting/bank/reconciliation': t`Bank reconciliation`,
        '/accounting/bank/smartpay': t`Smart Pay`,
        '/accounting/bank/smartpay/payments': t`Smart Pay Native`,
        '/accounting/bank/payments': t`Payments`,
        '/accounting/bank/accounts': t`Bank accounts`,
        '/accounting/bank/accounts/nordea': t`Bank accounts (Nordea)`,

        '/accounting/payroll': t`Payroll`,
        '/accounting/payroll/danloen': t`DanLøn`,

        'https://www.danlon.dk/': t`DanLøn`,
        'https://dataloen.bluegarden.dk': t`DataLøn`,
        'https://mit.proloen.dk/#!/login': t`ProLøn`,

        '/accounting/payroll/fi-notifications': t`FI notifications`,
        '/accounting/payroll/pbs-notifications': t`PBS notifications`,

        '/accounting/integration': t`Payroll and payments`,
        '/accounting/integration/import-kid-ocr-fbo': t`Import KID/OCR/FBO`,
        '/accounting/integration/golfbox': t`GolfBox`,

        '/accounting/scanning': t`Scanning`,
        '/accounting/scanning/incoming': t`Incoming`,
        '/accounting/scanning/upload': t`Add documents`,
        '/accounting/scanning/unprocessed': t`Unprocessed`,
        '/accounting/scanning/archive': t`Archive`,
        '/accounting/scanning/failed': t`Incoming failed`,
        '/accounting/scanning/categories': t`Scanning categories`,

        '/reports': t`Reports`,
        '/reports/statements': t`Financial statements`,
        '/reports/statements/period-total': t`Period total`,
        '/reports/statements/profit-and-loss': t`Profit and loss`,
        '/reports/statements/department-profit-and-loss': t`Department profit/loss`,
        '/reports/statements/balance-sheet': t`Balance sheet`,
        '/reports/statements/balance-posting': t`Trial balance`,
        '/reports/statements/key-figures': t`Key figures`,
        '/reports/statements/budget': t`Budget`,
        '/reports/statements/ledger-cards': t`Ledger cards`,
        '/reports/statements/entries': t`Entries`,
        '/reports/statements/accounts': t`Chart of accounts`,
        '/reports/statements/assets': t`Fixed assets`,
        '/reports/statements/prepayments': t`Prepayments`,
        // '/reports/statements/journals': '', // TODO: ???
        //
        '/reports/other': t`Other reports`,

        '/reports/customers': t`Customers`,
        '/reports/customers/ledger-cards': t`Customer ledger cards`,
        '/reports/customers/aged-debtors': t`Aged debtors`,
        '/reports/customers/turnover': t`Turnover statistics`,
        '/reports/customers/account-reconciliation': t`Customer control account reconciliation`,

        '/reports/suppliers': t`Suppliers`,
        '/reports/suppliers/ledger-cards': t`Supplier ledger cards`,
        '/reports/suppliers/aged-creditors': t`Aged creditors`,
        '/reports/suppliers/purchase': t`Purchase statistics`,
        '/reports/suppliers/account-reconciliation': t`Supplier control account reconciliation`,

        '/reports/vat': t`VAT`,
        '/reports/vat/statement': t`VAT statement`,
        '/reports/vat/statement-old': t`Old VAT statement`,
        '/reports/vat/detail': t`VAT detail`,
        '/reports/vat/eu-sales': t`Sales to EU customers`,
        '/reports/vat/b2c-eu-sales': t`Sales to private EU customers`,
        '/reports/vat/archive': t`Archive`,
        '/reports/vat/ltlv': t`VAT-LTLV`,
        '/reports/vat/ltlv/sales': t`VAT-LTLV Sales`,
        '/reports/vat/ltlv/buy': t`VAT-LTLV Buy`,
        '/reports/vat/ltlv/sales-abroad': t`VAT-LTLV Sales EU/Abr.`,
        '/reports/vat/ltlv/buy-abroad': t`VAT-LTLV Buy EU/Abr.`,

        '/reports/projects': t`Projects`,
        '/reports/projects/balance': t`Project balance`,
        '/reports/projects/variance': t`Project variance`,
        '/reports/projects/entries': t`Project entries`,
        '/reports/projects/cards': t`Project cards`,
        '/reports/projects/value': t`Project value`,
        '/reports/projects/employees': t`Employee statistics`,
        '/reports/projects/employees/reimbursement': t`Employee reimbursement`,
        '/reports/projects/employees/cards': t`Employee cards`,

        '/reports/liability': t`Client money ledger`,
        '/reports/liability/balance': t`Client money accounts balances`,
        '/reports/liability/adjustment': t`Adjustment of client money account balance`,

        '/reports/inventory': t`Inventory`,
        '/reports/inventory/product-ledger-cards': t`Product ledger cards`,
        '/reports/inventory/book-value': t`Inventory book value`,
        '/reports/inventory/stock-taking': t`Inventory checking`,
        '/reports/inventory/reordering': t`Reordering`,
        '/reports/inventory/purchase-statistics': t`Purchase statistics`,
        '/reports/inventory/deliveries-archive': t`Archive`,

        '/reports/budget123': t`budget123`,
        '/reports/budget123/dashboard': t`Dashboard`,

        '/inventory': t`Inventory`,
        '/inventory/purchases': t`Purchases`,
        '/inventory/purchases/orders': t`Purchase orders`,
        '/inventory/purchases/receipts': t`Receipts`,
        '/inventory/purchases/invoices': t`Supplier invoices`,
        '/inventory/purchases/archive': t`Archive`,
        '/inventory/purchases/sent': t`Sent`,

        '/inventory/suppliers': t`Suppliers`,
        '/inventory/suppliers/groups': t`Supplier groups`,

        '/inventory/products': t`Products`,
        '/inventory/products/groups': t`Product groups`,
        '/inventory/products/units': t`Units`,
        '/inventory/products/categories': t`Categories`,
        '/inventory/products/collections': t`Product collections`,
        '/inventory/products/discount-groups': t`Product discount groups`,
        '/inventory/products/price-groups': t`Price groups`,
        '/inventory/products/language-groups': t`Language layers`,

        '/inventory/deliveries': t`Delivery notes`,
        '/inventory/deliveries/archive': t`Delivery note archive`,
        '/inventory/deliveries/locations': t`Locations`,

        '/inventory/books': t`Inventory books`,
        // TODO: what to do here?
        // '/inventory/books/:draftNumber': '',

        '/payroll': t`Payroll`,

        '/projects': t`Projects`,
        '/projects/cases': t`Projects`,
        '/projects/cases/current': t`Current projects`,
        '/projects/cases/closed': t`Closed projects`,
        '/projects/cases/templates': t`Project templates`,

        '/projects/setup': t`Other setup`,
        '/projects/setup/activities': t`Activities`,
        '/projects/setup/expenses': t`Cost types`,
        '/projects/setup/statuses': t`Project statuses`,
        '/projects/setup/employees': t`Employees`,
        '/projects/setup/vacation': t`Time off in lieu`,
        '/projects/setup/holidays': t`Public holidays`,
        '/projects/setup/entries': t`Project entries`,

        '/projects/usage': t`Product usage`,
        '/projects/responsibility': t`Project responsibility`,
        '/projects/responsibility/projects': t`Projects`,
        '/projects/responsibility/employees': t`Employees`,
        '/projects/responsibility/invoices': t`Current invoices`,

        '/projects/ledger': t`Client money ledger`,
        '/projects/ledger/time-entry': t`Client accounts`,

        '/projects/entries': t({ message: 'Entries', context: 'registrations' }),
        '/projects/entries/time-entry': t`Time entry`,
        '/projects/entries/mileage': t`Mileage`,
        '/projects/entries/expenses': t`Expenses`,

        '/projects/groups': t`Project groups`,
        '/projects/groups/projects': t`Project groups`,
        '/projects/groups/cost': t`Cost groups`,
        '/projects/groups/activity': t`Activity groups`,
        '/projects/groups/employee': t`Employee groups`,

        '/journal-pro': t`Journal Pro`,

        '/website': t`Website`,
        '/webshop': t`Webshop`,
        '/webshop-plus': t`Webshop+`,
        '/inbox': t`Inbox`,
        '/market': t`Market`,
        // '/charlie': 'FIREBIRD_TAB_CHARLIE',
        '/settings': t`All settings`,
        '/settings/company': t`Company`,
        '/settings/company/master-information': t`Master information`,
        '/settings/company/logo': t`Logo`,
        '/settings/company/payment-link': t`Payment solutions`,
        '/settings/company/bank-accounts': t`Bank accounts`,
        '/settings/company/electronic-invoicing': t({ message: 'E-invoicing', context: 'Modtagelse af e-fakturaer' }),
        '/settings/company/electronic-invoicing-reception': t({ message: 'E-invoicing', context: 'Modtagelse af e-fakturaer' }),
        '/settings/company/master-data-fields': t`Master data fields`,
        '/settings/company/administrators': t`Administrators`,
        '/settings/company/log': t`Log`,
        '/settings/company/sent': t`Sent`,
        '/settings/company/export/data': t`Export data`,
        '/settings/company/export/tripletex': t`Export to Tripletex`,
        '/settings/company/export/eAccounting': t`Export to eAccounting`,
        '/settings/company/export/documents': t`Export documents`,
        '/settings/company/export/sie': t`Export SIE`,
        '/settings/company/export/saf-t': t`Export SAF-T`,
        '/settings/company/export/caseware': t`CaseWare export`,
        '/settings/company/anonymisation': t`Customer anonymization`,
        '/settings/company/new-features': t`New features`,

        '/settings/finance': t`Finance`,
        '/settings/finance/setups': t`Default setups`,
        '/settings/finance/accounts': t`Chart of accounts`,
        '/settings/finance/mirror-codes': t`Mirror codes`,
        '/settings/finance/accounts/system': t`System accounts`,
        '/settings/finance/accounts/vat': t`VAT codes`,
        '/settings/finance/accounts/charge': t`Charge accounts`,
        '/settings/finance/journals': t`Journals`,
        '/settings/finance/accounting-years': t`Accounting years`,
        '/settings/finance/fixed-exchange-rates': t`Fixed exchange rates`,

        '/settings/groups': t`Groups`,
        '/settings/groups/suppliers': t`Supplier groups`,
        '/settings/groups/customers': t`Customer groups`,
        '/settings/groups/products': t`Product groups`,
        '/settings/groups/assets': t`Asset groups`,

        '/settings/categories-and-units': t`Categories and units`,
        '/settings/categories-and-units/payment-terms': t`Payment terms`,
        '/settings/categories-and-units/units': t`Units`,
        '/settings/categories-and-units/notes': t`Note types`,
        '/settings/categories-and-units/number-series': t`Number series`,
        '/settings/categories-and-units/unbroken-number-series': t`Number series`,
        '/settings/categories-and-units/change-of-numbers': t`Change of numbers`,
        '/settings/categories-and-units/departments': t`Departments`,
        '/settings/categories-and-units/dimensions': t`Dimensions`,

        '/settings/inventory': t`Inventory`,
        '/settings/inventory/books': t`Inventory books`,

        '/settings/extensions': t`Extensions`,
        '/settings/extensions/web-hooks': t`Webhooks`,
        '/settings/extensions/tabs': t`Extra tabs`,
        '/settings/extensions/apps': t`Apps`,
        '/settings/extensions/website': t`Website`,

        '/settings/integrations': t`Integrations`,
        '/settings/integrations/smartbank': t`Bank integration`,
        '/settings/integrations/payment-link': t`Payment Link`,
        // '/settings/integrations/rackbeat': 'LEFTMENU_SETTINGS_RACKBEAT', // TODO: MISSING
        '/settings/integrations/payment-link-management': t`Payment solutions`,

        '/settings/subscription': t`Subscription`,
        '/settings/subscription/status': t`Subscription status`,
        '/settings/subscription/users': t`Users`,
        '/settings/subscription/modules': t`Add-on modules`,
        '/settings/subscription/extras': t`Access to extra features`,

        '/settings/workflows': t`Workflows`,
        '/settings/workflows/list': t`All Workflows`,
        '/settings/workflows/document': t`Document workflows`,
        '/settings/workflows/bank': t`Bank workflows`,

        '/expenses': t({ message: 'Expenses', id: 'TOP_NAVIGATION_EXPENSES_TAB' }),
        '/expenses/inbox': t`Documents`,
        '/expenses/inbox/pending': t`Pending document approval`,

        '/user': t`My settings`,
        '/user/master-information': t`My user information`,
        '/user/log': t`My log`,
        '/user/feedback': t`Feedback`,
        '/user/feedback/panel': t`User panel`,
        '/user/notes': t`Notes`,
        '/user/notes/follow-ups': t`Follow-ups`,
        '/user/notifications': t`Notifications`,
        '/user/notifications/history': t`Overview`,
        '/user/notifications/settings': t`Settings`,

        '/idea-bank': t`Idea bank`,
        '/chat': t`Chat`,
        '/logout': t`Log off`,
    };
};

export type RouteTextsMap = keyof ReturnType<typeof getRouteTexts>;

export type LegacyRouteTextsMap = keyof typeof legacyRouteTexts;

export const getRouteText = (route: string) => {
    const routeTextsMap = getRouteTexts();
    return routeTextsMap[route];
};

/**
 * Legacy route texts
 * @deprecated Use getRouteTexts instead
 */
export const legacyRouteTexts = {
    '/sales/dashboardV2': 'FIREBIRD_LEFTMENU_SALES_DASHBOARD',

    '/reports/statements/journals': '',

    '/inventory/books/:draftNumber': '',

    '/charlie': 'FIREBIRD_TAB_CHARLIE',

    '/settings/integrations/rackbeat': 'LEFTMENU_SETTINGS_RACKBEAT',
};
